import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { seoTags } from "../../constants/seo.mjs";

// Page head tags. The tag set itself is defined once in seoTags(), which the
// build step (scripts/prerender.mjs) also uses for the static HTML.
export default function Seo(props) {
  const { pathname } = useLocation();
  const tags = seoTags({ ...props, pathname });

  return (
    <Helmet>
      <title>{tags.title}</title>
      {tags.meta.map((attributes) => (
        <meta key={attributes.name ?? attributes.property} {...attributes} />
      ))}
      {tags.links.map((attributes) => (
        <link key={attributes.rel} {...attributes} />
      ))}
      {tags.jsonLd.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
